namespace('compass.hotel');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.EPSStayRecapWidget');
compass.require('compass.hotel.StayVisualizationWidget');
compass.require('compass.hotel.PriceSavingsExplanationWidget');
compass.requireLib('compass.util.format');

compass.hotel.ReservationConfirmationWidget = compass.defineWidget(function ReservationConfirmationWidget(options) {

	var me = this;
	var $j = jQuery;

	var _settings = options;
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;

	var _gds = _settings.gds || false;
	var _affiliate = _settings.stayRecap[0].summary.affiliate || 'GALILEO';

	var _stayRecapWidget;
	var _visualizationWidget;

	this.destroyWidget = function() {

	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		
		// Add redesign class if in redesign mode
		if (_settings.redesignMode) {
			widgetElem.addClass('reservationConfirmationWidget redesign');
		}
		
		var visualizationHolder = d.div({ className : 'stayVisualization'});
		_visualizationWidget = new compass.hotel.StayVisualizationWidget(visualizationHolder, {
			WUID : 'StayVisualization_' + _settings.WUID,
			stays : _settings.stays,
			nights : _settings.nights,
			roomType : _settings.roomType,
			bedType: _settings.stayRecap[0].summary.bedType,
			bedRequest: _settings.stayRecap[0].summary.bedRequest,
			gds : _gds,
			affiliate : _affiliate,
			currencyCode : _settings.meetingInfo.currencyCode,
			meetingInfo : _settings.meetingInfo
		});

		var stayRecapHolder = d.div({className : 'stayRecapHolder'});
		var updatedPrice = '';
		// choose stayRecap widget based upon affiliate
		if (_affiliate==='EAN'){
			var depositInfo = {
				'depositRequired': _settings.stayRecap[0].summary.depositRequired,
				'refundable': _settings.stayRecap[0].summary.refundable
			};
			_stayRecapWidget = new compass.hotel.EPSStayRecapWidget(stayRecapHolder, {
				WUID : 'epsStayRecapWidget_reservationConfirmationWidgetModal',
				meetingInfo: _settings.meetingInfo,
				recap: _settings.stayRecap[0].summary.recap,
				depositInfo: depositInfo,
				merchantOfRecord: _settings.stayRecap[0].summary.merchant_of_record,
				lite: true /* doesn't show hotel image and hotel info */
			});

			if (_settings.stayRecap[0].summary.status === 'price_changed') {
				updatedPrice = d.div( { className : 'updatedPrice' },
					d.div( { className : 'titleText' }, 'Updated Price' ),
					d.div( { className : 'p'}, 'The price of this room has changed since your initial search. You can proceed or select another room.')
				);
			}
		} else {
			/*stayRecapwidget expects all data to be in recapArray, not in a 'summary' key so we map it */
			/*this will be able to be removed once we standardize our json objects */
			var recapArray = _.map(_settings.stayRecap, function(s){
				return s.summary;
			});
			_stayRecapWidget = new compass.hotel.StayRecapWidget(stayRecapHolder, {
				WUID : 'stayRecapWidget_reservationConfirmationWidgetModal',
				GDS : _gds,
				recapArray : recapArray,
				meetingInfo: _settings.meetingInfo,
				chargingInfo: _settings.chargingInfo,
				lite: true /* doesn't show hotel image and hotel info */
			});
		}

		// The add more rooms link triggers an AddReservation event.
		var _hotelRateId = compass.generateId();

		var avgText = (_affiliate==='EAN') ? ' avg nightly web rate' : ' avg nightly event rate';

		widgetElem.append(
			d.div({ className : 'header' },
				updatedPrice,
				d.h4({ className : 'headerTitle' }, d.reader('Review reservation information and reserve rooms'),
					'Reserve Rooms'),
				d.div({ className : 'hotelName' }, _getHotelName(_settings.stayRecap)),
				d.div({ className : 'hotelRate' },
					d.span({'ARIA-labelledby': _hotelRateId}, _.template('<%= rate %> <%= currencyCode %>')({
						rate: _cf(_getHotelRate(_settings.stayRecap)),
						currencyCode: _settings.meetingInfo.currencyCode
					})),
					d.span({id: _hotelRateId}, d.abbr({alt:''}, ' |'),avgText),
					_settings.displayPriceSavings && _drawPriceSavings()
				)
			),
			visualizationHolder,
			stayRecapHolder,
			drawControls()
		);

		compass.trackPageView('ReserveRoomsSummary');
	};

	function drawControls() {
		function addMoreRoomsClicked() {
			if (_settings.canAddMoreRooms) {
				me.trigger("ReservationConfirmationWidget.AddReservation", {
					'stays': _settings.stayRecap
				});
			}
			return false;
		}

		function reserveRoomsClicked() {
			var button = jQuery(this);
			if(!button.hasClass('disabled')) {
				button.addClass('disabled').attr('aria-disabled', 'false');
				me.trigger("ReservationConfirmationWidget.reserveRoomsClicked",
						{ 'stays' : _settings.stayRecap });
			}
			return false;
		}

		function closeClicked() {
			me.trigger("ReservationConfirmationWidget.closeDialog");
			return false;
		}

		if(_settings.includeControls) {
			var diabledButtonClass = _settings.canAddMoreRooms ? '' : 'disabled';
			
			if (_settings.redesignMode) {
				// Redesign mode: Reserve button + Add more rooms link, no "No Thanks"
				return _d.div({ className : 'confirmationButtons redesign' },
					_d.button({
						className : 'reserve button',
						role : 'button',
						'ARIA-role' : 'button',
						tabindex : 0
					}, 'Reserve').activate(reserveRoomsClicked),
					!_gds && _settings.canAddMoreRooms ? _d.div({ className : 'addMoreRoomsLink' },
						_d.a({
							href: 'javascript:;',
							className: 'addMoreRooms'
						}, 'Add more rooms at this hotel').activate(addMoreRoomsClicked)
					) : null
				);
			} else {
				// Legacy mode: Next button + Add More Rooms button + No Thanks button
				return _d.div({ className : 'confirmationButtons' },
					_d.button({
						className : 'reserve button',
						role : 'button',
						'ARIA-role' : 'button',
						tabindex : 0
					}, 'Next').activate(reserveRoomsClicked),
					!_gds ? _d.button({
						className : 'add secondaryButton ' + diabledButtonClass,
						role : 'button',
						'ARIA-role' : 'button',
						tabindex : 0
					}, 'Add More Rooms').activate(addMoreRoomsClicked) : null,
					_d.button({
						className : 'closeDialog secondaryButton ',
						role : 'button',
						'ARIA-role' : 'button',
						tabindex : 0
					}, 'No Thanks').activate(closeClicked),
					_d.div({ className : 'clear' })
				);
			}
		}
	}

	function _getHotelRate(stayRecaps) {
		if (_affiliate==='EAN') {
			return stayRecaps[0].summary.avgRate;
		} else {
			var results = _.foldl(stayRecaps, function(acc, stay) {
				acc.count += Number(stay.summary.numNights);
				acc.sum += Number((stay.summary.inclusiveAvgRate || stay.summary.avgRate)) * Number(stay.summary.numNights);
				return acc;
			}, {
				count: 0,
				sum: 0
			});
		}

		return results.sum/results.count;
	}

	function _getHotelName(stayRecaps) {
		// HACK
		return stayRecaps.length > 0 ? stayRecaps[0].summary.hotelName : '';
	}
	
	function _drawPriceSavings() {
		var d = _d;

		var compareAtPrice = Math.round(_settings.stayRecap[0].summary.avgRate / (1.0 - _settings.meetingInfo.priceSavingsPercent));
		
		var linkDOM = d.span({className: 'priceSavingsExplanationLinkWrapper'}, 
			d.span({className: 'priceSavingsIcon'}, d.i({className:'fa-solid fa-dollar-circle'})),
			d.span({className: "priceSavingsExplanationLink"}, "Normally " + _settings.meetingInfo.currencySymbol + compareAtPrice + " per night")
		);

		linkDOM.activate(function() {
			compass.GA.trackEvent('Additional Information', 'Rate Comparison Description', 'Reserve Rooms Dialogue');
			priceSavingsDialog = new compass.hotel.PriceSavingsExplanationWidget(null, {
				priceSavingsPercent: _settings.meetingInfo.priceSavingsPercent
			});
		});
		
		return _d.span({}, 
			_d.abbr({alt:''}, ' |'),
			linkDOM
		);
	}

	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'CRAP',
	widgetName : 'ReservationConfirmationWidget',
	includeControls : true,
	displayPriceSavings: false
});

